import fetch from 'isomorphic-fetch';

const api = (requestUrl, args) => {
  return fetch(requestUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(args),
  })
    .then(response => {
      if (!response.ok && response.status !== 404) {
        throw new Error(response.statusText);
      }

      return response.json();
    })
};

export default api;
